import { Build, Component, h, Host, Prop, State } from '@stencil/core';
import { ListProduct } from '~model/product';
import { translate } from '~service/translation-service';

@Component({
  tag: 'uvex-product-last-seen',
  styleUrl: './product-last-seen.scss',
})
export class ProductLastSeen {
  @Prop() shopId: number;
  @Prop() articleId!: number;

  private version = 2;

  @State() products: ListProduct[] = [];

  get storageKey(): string {
    return `uvex.lastseenproducts-${this.shopId}-${this.version}`;
  }

  componentDidLoad() {
    if (!Build.isBrowser) {
      return;
    }
    const products: ListProduct[] = JSON.parse(localStorage.getItem(this.storageKey) || '[]');

    const lastSeenProduct = TYPO3.lastSeenProduct || { active: false, limit: 0, currentProduct: null };
    const { currentProduct, active, limit } = lastSeenProduct;
    if (active === false) {
      localStorage.removeItem(this.storageKey);
      return;
    }

    try {
      this.products = (products || []).filter(product => product.id !== currentProduct.id).slice(0, limit);
      localStorage.setItem(this.storageKey, JSON.stringify([currentProduct, ...this.products]));
    } catch (e) {
      localStorage.removeItem(this.storageKey);
    }
  }

  render() {
    if (this.products.length === 0) {
      return <Host hidden class="product-slider-wrap" />;
    }

    return (
      <Host hidden={false} class="product-slider-wrap">
        <h3>{translate('sw.lastSeenProducts.headline')}</h3>
        <uvex-slider-product class="carousel-shopware-style">
          {this.products.map(product => {
            return (
              <div class="carousel-slide">
                <uvex-product product={product} />
              </div>
            );
          })}
        </uvex-slider-product>
      </Host>
    );
  }
}
